import { useEffect } from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';

// A stale-chunk failure after a deploy shows up here as a dynamic-import error.
// If `vite:preloadError` did not already reload us, do it here — once, guarded
// by the same timestamp — so the user never has to hit Refresh themselves.
const CHUNK_RELOAD_KEY = 'chunk-reload-at';
const isStaleChunkError = (message) =>
  /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(String(message || ''));

export default function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  console.error('Router error:', error);

  useEffect(() => {
    if (!isStaleChunkError(error?.message)) return;
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - last < 10000) return; // just tried — show the error instead of looping
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  }, [error]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '20px'
      }}
    >
      <h2 style={{ marginBottom: '10px' }}>⚠ Something went wrong</h2>
      <p style={{ marginBottom: '25px', maxWidth: '400px' }}>{error?.statusText || error?.message}</p>

      <div>
        <button style={{ marginRight: '10px' }} className="btn btn-primary" onClick={() => navigate(-1)}>
          Go Back
        </button>

        <button style={{ marginLeft: '10px' }} className="btn btn-secondary ms-2" onClick={() => navigate('/')}>
          Home
        </button>
      </div>
    </div>
  );
}
